import { render, staticRenderFns } from "./OTPInput.vue?vue&type=template&id=e3728e20&scoped=true&"
import script from "./OTPInput.vue?vue&type=script&lang=js&"
export * from "./OTPInput.vue?vue&type=script&lang=js&"
import style0 from "./OTPInput.vue?vue&type=style&index=0&id=e3728e20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3728e20",
  null
  
)

export default component.exports